export default "__VITE_ASSET__3a3c28e4__"